import { Accordion, alpha, IconButton, styled } from "@mui/material";
import Dialog from "components/elements/Dialog";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";

export const StyledDialog = styled(Dialog)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    "& .MuiDialog-paper": {
      backgroundColor: colors.gray50,
      borderRadius: "8px",
      padding: 0,
      maxWidth: "731px",
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2, 1),
      },
    },

    ".MuiDialogTitle-root": {
      maxWidth: "80%",
    },
  };
});

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: "#B2B4B9",
  [theme.breakpoints.up("sm")]: {
    right: theme.spacing(1.5),
    top: theme.spacing(1.5),
  },
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    border: `1px solid ${alpha(colors.black, 0.1)}`,
    boxShadow: "none",
    "&:before": {
      display: "none",
    },

    "&&.MuiPaper-root": {
      backgroundColor: colors.white,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2.25, 2),
      marginBottom: 0,

      "&.Mui-expanded": {
        border: `1.5px solid ${theme.palette.primary.main}`,
      },

      "& > .MuiButtonBase-root": {
        padding: 0,
      },

      "& .MuiAccordionSummary-content": {
        margin: 0,
      },

      "& .MuiAccordionSummary-root": {
        minHeight: "unset",
      },
    },
  };
});
